// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui.form .fields .field {\n\tposition: relative;\n}\n\n.ui.pointing.label.prompt {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0.5em;\n\tz-index: 1;\n}\n\n.buttonLabelGroup {\n\tdisplay: flex;\n\tgap: 10px;\n\talign-items: center;\n\tmargin: 0px 0px 0.285714rem;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Content/Farms/NewEditFarm/form.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,2BAA2B;AAC5B","sourcesContent":[".ui.form .fields .field {\n\tposition: relative;\n}\n\n.ui.pointing.label.prompt {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0.5em;\n\tz-index: 1;\n}\n\n.buttonLabelGroup {\n\tdisplay: flex;\n\tgap: 10px;\n\talign-items: center;\n\tmargin: 0px 0px 0.285714rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui": "ui",
	"form": "form",
	"fields": "fields",
	"field": "field",
	"pointing": "pointing",
	"label": "label",
	"prompt": "prompt",
	"buttonLabelGroup": "buttonLabelGroup"
};
export default ___CSS_LOADER_EXPORT___;
